<template>
  <pt-gene-report-apply-list class="pt-gene-report-apply-list__page"></pt-gene-report-apply-list>
</template>

<script>
import PtGeneReportApplyList from 'cps//pt-gene-report-apply-list/withData'
export default {
  name: 'pt-gene-report-apply-list__view',
  components: {
    'pt-gene-report-apply-list': PtGeneReportApplyList
  }
}
</script>
